import React from "react";
import { Button, Drawer } from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";

import { useDispatch, useSelector } from "react-redux";
import { setFilters } from "redux/store/filters/action";
import FilterUnit from "./components/FilterUnit";

interface Props {
  onClose: () => void;
  open: boolean;
}

const FiltersDrawer = ({ onClose, open }: Props) => {
  const { filters }: { filters: Array<Array<any>> } = useSelector(
    // @ts-ignore
    (state) => state.filters
  );

  const dispatch = useDispatch();
  const setFilter = (index: number) => (newFilter: Array<any>) => {
    const newFilters = [...filters];
    newFilters.splice(index, 1, newFilter);
    dispatch(setFilters(newFilters));
  };

  const deleteFilter = (index: number) => () => {
    const newFilters = [...filters];
    newFilters.splice(index, 1);
    dispatch(setFilters(newFilters));
  };

  const addFilter = () => {
    dispatch(setFilters([...filters, [null, null, null, null]]));
  };

  return (
    <Drawer
      width={800}
      title="User Filters"
      placement="right"
      onClose={onClose}
      open={open}
    >
      {filters.map((filter, index) => (
        <div key={index} className="flex items-center gap-2 mb-2">
          <FilterUnit
            filter={filter}
            setFilter={setFilter(index)}
            firstFilter={index === 0}
          />
          <div
            className="w-6 h-6 rounded flex items-center justify-center transition hover:bg-teal-200 cursor-pointer"
            onClick={deleteFilter(index)}
          >
            <DeleteOutlined className="text-red-700 " />
          </div>
        </div>
      ))}
      <Button className="mt-4" icon={<PlusOutlined />} onClick={addFilter}>
        Add Filter
      </Button>
    </Drawer>
  );
};

export default FiltersDrawer;
